
import { useEffect, useState } from "react";
import { FaInstagram } from "react-icons/fa";
import { ArrowRight } from "lucide-react";
import { settingsApi } from "@/integrations/mysql/client";

interface NewsletterData {
  title: string;
  description: string;
  buttonText: string;
  buttonUrl: string;
}

const DEFAULT: NewsletterData = {
  title: "Acompanhe no Instagram",
  description: "Dicas diárias de nutrição, receitas saudáveis e conteúdo exclusivo direto no seu feed.",
  buttonText: "Seguir @brenda.nutricionista",
  buttonUrl: "https://www.instagram.com/brenda.nutricionista/",
};

export function Newsletter() {
  const [data, setData] = useState<NewsletterData>(DEFAULT);

  useEffect(() => {
    settingsApi.list()
      .then(list => {
        const raw = list.find(s => s.key === 'newsletter_instagram')?.value;
        if (raw) {
          try { setData({ ...DEFAULT, ...JSON.parse(raw) }); } catch { /**/ }
        }
      })
      .catch(() => {});
  }, []);

  return (
    <section className="py-14 bg-brand-primary">
      <div className="container mx-auto px-6 text-center max-w-2xl">
        <div className="w-12 h-12 bg-white/15 rounded-2xl flex items-center justify-center mx-auto mb-5">
          <FaInstagram className="w-6 h-6 text-white" />
        </div>
        <h2 className="text-2xl sm:text-3xl font-bold text-white font-primary mb-3">
          {data.title}
        </h2>
        <p className="text-white/75 text-sm sm:text-base mb-7 leading-relaxed">
          {data.description}
        </p>
        <a
          href={data.buttonUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 bg-white text-brand-primary font-bold font-primary px-7 py-3 rounded-full shadow-md hover:bg-white/90 transition-colors"
        >
          <FaInstagram className="w-5 h-5" />
          {data.buttonText}
          <ArrowRight className="w-4 h-4" />
        </a>
      </div>
    </section>
  );
}
